module.exports = __webpack_public_path__ + "assets/img/1_1650_big.b0d76344.jpg";